module.exports = __webpack_public_path__ + "img/4.dfeaaa54.png";